import UISelect from 'UIComponents/input/UISelect';
//@ts-expect-error file not typed
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import { INPUT_WIDTHS } from '../../constants/inlineLayout';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { getBaseEventBasedFilterFamilyField } from '../../strategy/eventBasedFilters';
import { useMemo } from 'react';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import EditorConditionValueInput from './EditorConditionValueInput';
import EditorCommunicationSubscriptionRelatedConditionsGroup from './EditorCommunicationSubscriptionRelatedConditionsGroup';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorCommunicationSubscriptionRelatedConditionsGroupResponsive = props => {
  var _condition$field;
  const {
    filterFamily,
    condition,
    conditionPath,
    inputUse
  } = props;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const statusCondition = useMemo(() => {
    return condition.set('field', getBaseEventBasedFilterFamilyField(filterFamily));
  }, [condition, filterFamily]);

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = !!((_condition$field = condition.field) !== null && _condition$field !== void 0 && _condition$field.userHasNoAccess);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    disableValueInput,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: statusCondition,
    disabled: userHasNoAccess,
    filterFamily,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: onFieldConditionValueChange
  });
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorCommunicationSubscriptionRelatedConditionsGroup, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      wrap: false,
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: filterFamily,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          width: INPUT_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: disableOperatorSelection,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: statusCondition.constructor.toString()
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          alignSelf: 'start',
          width: INPUT_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: statusCondition,
          disabled: disableValueInput,
          filterFamily: filterFamily,
          inputUse: inputUse,
          onChange: onFieldConditionValueChange,
          size: "md"
        })
      })]
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    })]
  });
};
export default EditorCommunicationSubscriptionRelatedConditionsGroupResponsive;